import React, { useLayoutEffect, useState } from "react"
import { Paper } from "@material-ui/core"
import { useHistory } from "react-router-dom"

import PERMISSIONS_CODES from "constants/permission-codes"
import { ROUTE_RECEIPT_OF_INVOICE } from "constants/routeConstants"

import useShowSnackbar from "utils/snackbar-hooks"
import useCheckPermission from "utils/auth/useCheckPermission"
import {
  sendAndHandleInvalidToken,
  useWrapHandleInvalidToken,
} from "utils/invalid-token"

import ApiReceiptOfInvoice from "services/api-receipt-of-invoice"
import ApiCustomer from "services/api-customer"
import ApiInvoice from "services/api-invoice"

import NotAllowedNotice from "components/NotAllowedNotice"
import ReceiptOfInvoiceForm from "components/receipt-of-invoice/ReceiptOfInvoiceForm"

const PAGE_PERMISSIONS = [PERMISSIONS_CODES.WRITE_RECEIPT_OF_INVOICE]

const fetchCustomer = async () => ((await ApiCustomer.get()) || []).data

const fetchInvoiceData = async (customerId) =>
  (
    await ApiInvoice.get({
      customerId,
      fromColumns: ["invoiceNumber"],
      includeCanceled: false,
      limit: 10,
    })
  )?.data || []

function ReceiptOfinvoiceCreatePage() {
  const history = useHistory()
  const [defaultValue] = useState(() => {
    const json = localStorage.getItem("invoiceItem")

    if (!json) return undefined

    localStorage.removeItem("invoiceItem")
    return JSON.parse(json)
  })

  const [showSnackbar, showSnackbarLoading, hideSnackbar] = useShowSnackbar()

  const { allowed, checking, initialized, check } = useCheckPermission()

  const wrappedFetchCustomerData = useWrapHandleInvalidToken(
    fetchCustomer,
    () => []
  )

  const wrappedFetchInvoiceData = useWrapHandleInvalidToken(
    fetchInvoiceData,
    () => []
  )
  const [isSubmitting, setIsSubmitting] = useState(false)

  useLayoutEffect(() => {
    check({ permissions: PAGE_PERMISSIONS })
  }, [check])

  const handleCancel = () => {
    history.push(ROUTE_RECEIPT_OF_INVOICE)
  }

  const handleSubmit = async (formData) => {
    // formData diharapkan sudah dalam shape:
    // { userId, customerId, detailInvoiceIds: number[], detailAmounts: (number|string)[] }
    setIsSubmitting(true)
    showSnackbarLoading("Creating receipt of invoice...")

    let fetchState = {}

    try {
      fetchState = await sendAndHandleInvalidToken(() =>
        ApiReceiptOfInvoice.create(formData)
      )
    } catch (err) {
      setIsSubmitting(false)
      showSnackbar(
        err?.errors?.[0]?.message ?? "Cannot create receipt of invoice."
      )
      return
    }

    if (fetchState.success) {
      const { data } = fetchState.response
      // ApiReceiptOfInvoice.create() mengembalikan:
      // { data: { ok, roiId } }
      showSnackbar("Receipt of invoice successfully created.")
      history.push(`${ROUTE_RECEIPT_OF_INVOICE}/${data.roiId}`)
    } else {
      setIsSubmitting(false)
      // kasus invalid token, dll
      hideSnackbar()
    }
  }

  if (checking || !initialized) {
    return null
  }

  if (!allowed) {
    return (
      <Paper style={{ maxWidth: "800px" }}>
        <NotAllowedNotice />
      </Paper>
    )
  }

  return (
    <ReceiptOfInvoiceForm
      isUpdate={false}
      isSubmitting={isSubmitting}
      defaultValue={defaultValue}
      fetchCustomerData={wrappedFetchCustomerData}
      fetchInvoiceData={wrappedFetchInvoiceData}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  )
}

export default ReceiptOfinvoiceCreatePage
